export const APP_VERSION = '4.1.0';
